import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { Header, PageWithTitle, FlexRow, FlexColumn } from '../styles/Containers'
import { PageTitle } from '../styles/Text'
import SettingsMenu from './SettingsMenu'

// Stretch so SettingsMenu's MenuRail can fill the row height while StickyMenuContent handles sticky sizing.
const ContentRow = styled(FlexRow)`
  align-items: stretch;
  width: 100%;
`

function SettingsPageTemplate({ children }) {
  return (
    <PageWithTitle gap="15px">
      <Header>
        <PageTitle>Settings</PageTitle>
      </Header>
      <ContentRow>
        <SettingsMenu />
        <FlexColumn width="100%" gap="10px" padding="10px 0 0">
          {children}
        </FlexColumn>
      </ContentRow>
    </PageWithTitle>
  )
}

SettingsPageTemplate.propTypes = {
  children: PropTypes.node
}

export default SettingsPageTemplate
